import * as React from 'react';
/**
 *
 * Original name: Dropbox Replay
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=23845%3A2798
 *
 */
export const DropboxReplayLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M4.95 15.058V8.91L12 3.975v6.099l-2.705 1.918L12 13.894v6.131l-7.05-4.967Zm7.05 0V8.91l7.05-4.935v6.099l-2.705 1.918 2.705 1.902v6.131L12 15.058Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
